exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navav-logo-container {\n  width: 250px;\n  padding: 0 10px;\n  font-weight: bold;\n  color: #212b31;\n  text-decoration: none; }\n  .navav-logo-container:hover {\n    text-decoration: none; }\n  .navav-logo-container img {\n    border-radius: 50%;\n    margin-right: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/components/app-header/app-header.component.scss
// module id = ../../../../../src/app/components/app-header/app-header.component.scss
// module chunks = main